import React from 'react'
import dynamic from 'next/dynamic'
import Layout from '../components/layout/layout'
import styles from 'components/about/about.module.scss'
import AboutBanner from 'components/about/about-banner/index'

const LogoBar = dynamic(() => import('components/share/logo-bar/index'))
const AboutMeetCoach = dynamic(() => import('components/about/about-meet-coach/index'))
const AboutBoxNumber = dynamic(() => import('components/about/about-box-number/index'))
const AboutReason = dynamic(() => import('components/about/about-reason/index'))
const AboutSlogan = dynamic(() => import('components/about/about-slogan/index'))
const AboutPodCast = dynamic(() => import('components/about/about-podcast/index'))
const AboutChamps = dynamic(() => import('components/about/about-champs/index'))
const MakingExcuse = dynamic(() => import('components/share/making-excuse/index'))
const ChooseProgram = dynamic(() => import('components/share/choose-program/index'))

export default function WhoIsMikeDolce (props) {
  return (
    <Layout isSubscribe={false}>
      <div className={styles['about-container']}>
        <AboutBanner />
        <LogoBar />
        <AboutMeetCoach />
        <AboutBoxNumber />
        <AboutReason />
        <AboutSlogan />
        <AboutPodCast />
        <AboutChamps />
        <MakingExcuse
          image='/static/images/about/bg-excuse.png'
          title='ready to get started? no excuses.'
          textButton='SIGN ME UP'
        />
        <ChooseProgram />
      </div>
    </Layout>
  )
}
